import api from '../../shared/api/axios';
import type { Me } from './types';

function persistAccessToken(token: string) {
    localStorage.setItem('accessToken', token);
}

function persistMe(user: Me) {
    localStorage.setItem('me', JSON.stringify(user));
}

export function readStoredMe(): Me | null {
    const raw = localStorage.getItem('me');
    if (!raw) return null;

    try {
        return JSON.parse(raw) as Me;
    } catch {
        localStorage.removeItem('me');
        return null;
    }
}

export async function register(params: { email: string; name: string; password: string }) {
    const { data } = await api.post('/auth/register', params);
    // {}
    return data;
}

export async function login(params: { email: string; password: string }) {
    const { data } = await api.post('/auth/login', params);
    // { ok: true, data: { user: { id: '', email: '', name: '' }, token: '...' } }
    const token = data?.data?.token as string | undefined;
    const user = data?.data?.user as Me | undefined;
    if (!token) {
        throw new Error('토큰이 없습니다.');
    }
    persistAccessToken(token);
    if (user) {
        persistMe(user);
    }
    return { token, user };
}

export async function getMe() {
    const r = await api.get('/auth/me');
    // 백엔드가 { ok, data } 혹은 그냥 { id, email, name } 중 하나를 줄 수 있음
    return r.data?.data ?? r.data;
}

export async function changePassword(params: { currentPassword: string; newPassword: string }) {
    const { data } = await api.post('/auth/change-password', params);
    const user = (data?.data ?? data) as Me;
    if (user) {
        persistMe(user);
    }
    return user;
}
